<template>
  <div :class="$style.page">
    <div :class="$style.videoWrapper" ref="videoWrapper">
      <video :class="$style.video" ref="video" preload="auto" loop playsinline autoplay muted src="../../../assets/video/geekbang.mp4" @canplay="canplay"></video>
      <div :class="$style.overlay">
        <h1 :class="$style.baseTitle">推动数字人才全面发展 助力数字中国早日实现</h1>
        <div :class="$style.baseSubtitle">成为全球卓越的数字人才发展平台</div>
      </div>
    </div>
    <div :class="$style.moduleMap">
      <img :class="$style.businessMapImg" :src="businessMapImg">
    </div>
    <div :class="$style.moduleList">
      <div :class="$style.moduleWrapper" :key="index" v-for="(item, index) in productList">
        <div :class="[$style.module, $style[`module${index + 1}`]]">
          <Card :class="$style.card" :product="item" :logoHeight="item.logoHeight" />
          <img :class="$style.introImg" :src="item.introImg" :style="{height: `${item.introImgHeight}px`}">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import businessMapImg from '@/assets/img/home/business-map.png'

import { getProductList } from '../data'

import Card from './Card.vue'

export default {
  components: {
    Card
  },
  data () {
    return {
      businessMapImg,
      productList: getProductList()
    }
  },
  created () {

  },
  mounted () {
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler () {
      this.setVideoWrapperStyle()
    },

    canplay () {
      this.$nextTick(() => {
        this.setVideoWrapperStyle()
      })
    },

    setVideoWrapperStyle () {
      const height = this.$refs.video.offsetHeight
      this.$refs.videoWrapper.style.height = height + 'px'
    }
  }
}
</script>

<style lang="scss" module>
.videoWrapper {
  min-height: 600px;
  position: relative;
  overflow: hidden;
  text-align: center;
  background-size: 100% 100%;

  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 600px;
    object-fit: cover;
    // object-position: 50% 60%;
    transform-style: preserve-3d;
  }
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .baseTitle {
    line-height: 74px;
    letter-spacing: 2px;
    font-size: 50px;
    font-weight: 500;
    color: #fff;
  }

  .baseSubtitle {
    font-size: 28px;
    color: #fff;
    line-height: 40px;
    letter-spacing: 2px
  }
}

.moduleMap {
  display: flex;
  justify-content: center;
}

.businessMapImg {
  width: auto;
  height: 560px;
  object-fit: cover;
}

.moduleList {
  margin-top: -80px;
}

.moduleWrapper {

  &:nth-child(odd) {
    .module {
      padding-left: 99px;
    }
  }

  &:nth-child(even) {
    background: linear-gradient(3deg, #FFF9F0 0%, #FFF8EC 100%);

    .module {
      justify-content: flex-end;
      padding-right: 110px;
    }

    .introImg {
      order: 1;
    }

    .card {
      order: 2;
    }
  }
}

.module {
  position: relative;
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 80px 0;
  width: 1400px;
  margin: 0 auto;

  .introImg {
    position: absolute;
    top: 0;
  }
}

// 极客时间
.module1 {
  .introImg {
    position: absolute;
    top: 80px;
    right: 8px;
  }
}

.module2 {
  .introImg {
    position: absolute;
    top: 90px;
    left: -72px;
  }
}

.module3 {
  .introImg {
    position: absolute;
    top: 56px;
    right: -18px;
  }
}

.module4 {
  .introImg {
    position: absolute;
    top: 87px;
    left: 28px;
  }
}

.module5 {
  padding-top: 96px;

  .introImg {
    position: absolute;
    top: 102px;
    right: -12px;
  }
}

.module6 {
  [data-title] {
    margin-top: 16px;
  }

  .introImg {
    position: absolute;
    top: 60px;
    left: -116px;
  }
}
</style>
